import * as React from 'react';
import {LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import {Group} from '../../types/types';
import {LoanMigrationViewProps} from '../../types/components';

class LoanMigrationView extends React.Component<LoanMigrationViewProps, {}> {

    renderMigrationSuccess(originGroup: Group, targetGroup: Group, isSuccess: boolean) {
        if (isSuccess) {
            return <React.Fragment>
                <p>
                Se migró la solicitud hacia el
                grupo {targetGroup.value}.
                </p>
                <br/>
            </React.Fragment>;
        }
        return <React.Fragment>
            <p>
                Al cambiar la agencia/lote se migrará la solicitud de crédito del grupo
                "<b>{originGroup.value}&nbsp;</b>" al grupo "<b>{targetGroup.value}</b>".
            </p>
            <br/>
        </React.Fragment>;
    }

    onPressMigrationConfirm = () => this.props.onPressMigrationConfirm(this.props.targetGroup);

    renderButton(isSuccess, onPressMigrationConfirm, onPressClose) {
        if (isSuccess) {
            return <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onPressClose}>{LOAN_APPLICATION_MX.MIGRATE_LOAN_FINISH_BUTTON}</a>;
        }
        return <div><a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                       onClick={onPressClose}>{LOAN_APPLICATION_MX.MIGRATE_LOAN_CANCEL_BUTTON}</a>
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onPressMigrationConfirm}>{LOAN_APPLICATION_MX.MIGRATE_LOAN_CONFIRM_BUTTON}
            </a></div>;
    }

    render() {
        const {
            originGroup, targetGroup,
            onPressClose, isSuccess
        } = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderMigrationSuccess(originGroup, targetGroup, isSuccess)}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(isSuccess, this.onPressMigrationConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default LoanMigrationView;